<template>
    <div class="menu-bar-content" :style="{ 'background-color': backgroundColor }"><slot></slot></div>
</template>

<script>
import Globals from "../../globals";
import { mapActions } from "vuex";

export default {
    props: {
        id: { type: String, default: () => Globals.UUID() },
        backgroundColor: { type: String, default: "#3c3c3c" },
        backgroundColorActive: { type: String, default: "#878787" }
    },
    data() {
        return {};
    },
    computed: {},
    created() {
        this.addMenu(this.id);
    },
    mounted() {},
    methods: {
        ...mapActions("gui/menubar", {
            addMenu: "addMenu"
        })
    }
};
</script>

<style lang="scss" scoped>
.menu-bar-content {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// MenuBar.vue?aae198be